import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const TickIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  onClick,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      onClick={onClick}
      {...rest}
    >
      <path
        d="M15.4, 1.3 C15.4, 1.3 11.8666667, 4.86666667 4.8, 12 L0.6, 7.7 L1.8, 6.4 L4.8, 9.4 L14.2, 0.1 C15, 0.9 15.4, 1.3 15.4, 1.3 Z"
        data-testid="icon-tick"
        fill={customColour}
        className={styles[className]}
        transform="translate(0.000000, 2.000000)"
      />
    </Icon>
  )
}
